
import { processCSV } from '@process-advisor/process-miner/api/methods/data/processCSV';
import { uploadEventLog } from '@process-advisor/process-miner/api/methods/data/uploadEventLog';
import { setDataType } from '@process-advisor/process-miner/api/methods/data/setDataType';
import { setDataMapping } from '@process-advisor/process-miner/api/methods/data/setDataMapping';
import { exportEventLog } from '@process-advisor/process-miner/api/methods/data/exportEventLog';
import { updateDataTransformation } from '@process-advisor/process-miner/api/methods/data/updateDataTransformation'
import { saveFilteredOnly } from '@process-advisor/process-miner/api/methods/data/setSaveFilteredOnly'
import { updateLoadingStatus } from '@process-advisor/process-miner/api/methods/data/updateLoadingStatus'

export const dataMethods = {
    processCSV,
    uploadEventLog,
    setDataType,
    setDataMapping,
    exportEventLog,
    updateDataTransformation,
    saveFilteredOnly,
    updateLoadingStatus,
};
